import axios from 'axios'
import { BASE_URL } from './constants'
import { Toast } from 'antd-mobile'
const instance = axios.create({
  baseURL:BASE_URL
})
 
instance.interceptors.response.use((response) => {
  if(response.data.code !== 0) {
    Toast.show({
      icon: 'fail',
      content: response.data.message
    })  
  }
  return response.data
},(error) => {
  // console.log(error)
  try{
    const msg = error.response.data.message
    return Promise.reject({message: msg})
  } catch (e){
    return Promise.reject(error)
  }
  
})

export default instance